(function () {
  var CONFIG = {
    setName: "DEWALT KONFEXRON",
    setPriceLabel: "899 €",
    maxMachines: 3,

    priceProduct: {
      handle: "dewalt-xr-selectset-aktionspreis",
      displayTitle: "DEWALT KONFEXRON – Aktionspreis",
      shortLabel: "Setpreis",
      model: "KONFEXRON-899"
    },

    batteryOptions: [
      {
        key: "option-1-powerstack",
        optionLabel: "Akku-Set Option 1",
        handle: "dewalt-akku-kit-2x-18v-5ah-ps-plus-dcb1104-dcb1104h2-qw",
        displayTitle: "Option 1: PowerStack Set",
        shortLabel: "PowerStack",
        model: "DCB1104H2-QW",
        description: "1x Ladegerät + 2x 18V 5.0 Ah PowerStack Akku"
      },
      {
        key: "option-2-xr",
        optionLabel: "Akku-Set Option 2",
        handle: "dewalt-akku-kit-3x-18v-5ah-plus-dcb1104-dcb1104p3-qw",
        displayTitle: "Option 2: XR 5Ah Set",
        shortLabel: "XR 5Ah",
        model: "DCB1104P3-QW",
        description: "1x Ladegerät + 3x 18V XR 5.0 Ah Akku"
      }
    ],

    machines: [
      {
        handle: "dewalt-akku-multi-tool-18v-basisversion-dcs356nt-xj",
        displayTitle: "Akku-Multi-Tool",
        model: "DCS356NT-XJ",
        shortLabel: "Multi-Tool"
      },
      {
        handle: "dewalt-akku-hobel-82mm-18v-basisv-dcp580nt-xj",
        displayTitle: "Akku-Hobel 82 mm",
        model: "DCP580NT-XJ",
        shortLabel: "Hobel"
      },
      {
        handle: "dewalt-akku-heckenschere-18-volt-basisv-dcmht562n-xj",
        displayTitle: "Akku-Heckenschere",
        model: "DCMHT562N-XJ",
        shortLabel: "Heckenschere"
      },
      {
        handle: "dewalt-akku-led-baustellenstrahler-18-volt-dcl079-xj",
        displayTitle: "Akku-LED-Baustellenstrahler",
        model: "DCL079-XJ",
        shortLabel: "Strahler"
      },
      {
        handle: "dewalt-akku-schlagschrauber-1-4-18-volt-dcf860nt-xj",
        displayTitle: "Akku-Schlagschrauber 1/4",
        model: "DCF860NT-XJ",
        shortLabel: "1/4 Schlagschrauber"
      },
      {
        handle: "dewalt-saebelsaege-18v-basisv-dcs367nt-xj",
        displayTitle: "Akku-Säbelsäge",
        model: "DCS367NT-XJ",
        shortLabel: "Säbelsäge"
      },
      {
        handle: "dewalt-akku-geblaese-18-volt-basisv-dcmbl562n-xj",
        displayTitle: "Akku-Gebläse",
        model: "DCMBL562N-XJ",
        shortLabel: "Gebläse"
      },
      {
        handle: "dewalt-akku-exzenterschleifer-18-v-basisv-dcw210nt-xj",
        displayTitle: "Akku-Exzenterschleifer",
        model: "DCW210NT-XJ",
        shortLabel: "Exzenterschleifer"
      },
      {
        handle: "dewalt-akku-stichsaege-18-v-basisv-dcs335nt-xj",
        displayTitle: "Akku-Stichsäge",
        model: "DCS335NT-XJ",
        shortLabel: "Stichsäge"
      },
      {
        handle: "dewalt-akku-und-netz-kompakt-radio-dcr029-qw",
        displayTitle: "Akku- & Netz-Kompaktradio",
        model: "DCR029-QW",
        shortLabel: "Radio"
      },
      {
        handle: "dewalt-akku-handkreissaege-18v-basisv-dcs572nt-xj",
        displayTitle: "Akku-Handkreissäge",
        model: "DCS572NT-XJ",
        shortLabel: "Handkreissäge"
      },
      {
        handle: "dewalt-hydraul-akku-schlagschrauber-1-4-18v-dcf870nt-xj",
        displayTitle: "Hydraulik-Schlagschrauber 1/4",
        model: "DCF870NT-XJ",
        shortLabel: "Hydraulik 1/4"
      },
      {
        handle: "dewalt-akku-ratsche-1-2-18v-basisv-dcf512n-xj",
        displayTitle: "Akku-Ratsche 1/2",
        model: "DCF512N-XJ",
        shortLabel: "Ratsche"
      },
      {
        handle: "dewalt-akku-kombihammer-18v-basisv-dch273nt-xj",
        displayTitle: "Akku-Kombihammer",
        model: "DCH273NT-XJ",
        shortLabel: "Kombihammer"
      },
      {
        handle: "dewalt-akku-schlagschrauber-1-2-18v-basisv-dcf922nt-xj",
        displayTitle: "Akku-Schlagschrauber 1/2",
        model: "DCF922NT-XJ",
        shortLabel: "1/2 Schlagschrauber"
      },
      {
        handle: "dewalt-akku-schlagbohrschrauber-18v-basisv-dcd1007nt-xj",
        displayTitle: "Akku-Schlagbohrschrauber",
        model: "DCD1007NT-XJ",
        shortLabel: "Schlagbohrschrauber"
      },
      {
        handle: "dewalt-akku-winkelschl-125-mm-18-v-basisv-dcg405nt-xj",
        displayTitle: "Akku-Winkelschleifer 125 mm",
        model: "DCG405NT-XJ",
        shortLabel: "Winkelschleifer"
      }
    ],

    freebies: [
      {
        handle: "stanley-wasserwaage-torpedo-fatmax-alu-22cm-0-43-603",
        displayTitle: "Stanley Wasserwaage",
        model: "0-43-603"
      },
      {
        handle: "stanley-cutter-fatmax-mit-magazin-18mm-1-10-481",
        displayTitle: "Stanley FatMax Cutter",
        model: "1-10-481"
      },
      {
        handle: "stanley-bandma-tylon-5m-19mm-1-30-697",
        displayTitle: "Stanley Bandmaß 5 m",
        model: "1-30-697"
      },
      {
        handle: "dewalt-werkzeugtasche-49-liter-dwst60104-9",
        displayTitle: "DEWALT Werkzeugtasche 49 l",
        model: "DWST60104-9"
      }
    ]
  };

  var root = "/";
  if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
    root = window.Shopify.routes.root;
  }

  if (root.slice(-1) !== "/") {
    root += "/";
  }

  var container = document.getElementById("xr-select-configurator");
  if (!container) return;

  var els = {
    batteryOptions: container.querySelector("[data-battery-options]"),
    machineGrid: container.querySelector("[data-machine-grid]"),
    freebieGrid: container.querySelector("[data-freebie-grid]"),
    machineCount: container.querySelector("[data-machine-count]"),
    progressBar: container.querySelector("[data-progress-bar]"),
    statusStep: container.querySelector("[data-status-step]"),
    statusTitle: container.querySelector("[data-status-title]"),
    selectionSummary: container.querySelector("[data-selection-summary]"),
    addButton: container.querySelector("[data-add-set]"),
    message: container.querySelector("[data-message]")
  };

  var state = {
    products: {},
    selectedBattery: null,
    selectedMachines: [],
    isAdding: false
  };

  function buildProductUrl(handle) {
    return root + "products/" + handle + ".js";
  }

  function buildCartAddUrl() {
    return root + "cart/add.js";
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function normalizeImage(src) {
    if (!src) return "";
    if (typeof src === "object" && src.src) src = src.src;
    if (src.indexOf("//") === 0) return "https:" + src;
    return src;
  }

  function getProductImage(product) {
    if (!product) return "";
    if (product.featured_image) return normalizeImage(product.featured_image);
    if (product.images && product.images.length) return normalizeImage(product.images[0]);
    return "";
  }

  function findFirstAvailableVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;

    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) return product.variants[i];
    }

    return product.variants[0];
  }

  function fetchProduct(def) {
    return fetch(buildProductUrl(def.handle), {
      method: "GET",
      headers: {
        "Accept": "application/json"
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Produkt konnte nicht geladen werden: " + def.handle);
        }

        return response.json();
      })
      .then(function (product) {
        var variant = findFirstAvailableVariant(product);
        var available = Boolean(product.available && variant && variant.available);

        return {
          handle: def.handle,
          key: def.key || def.handle,
          optionLabel: def.optionLabel || "",
          displayTitle: def.displayTitle || product.title || def.handle,
          title: product.title || def.displayTitle || def.handle,
          shortLabel: def.shortLabel || def.displayTitle || product.title || def.handle,
          model: def.model || "",
          description: def.description || "",
          image: getProductImage(product),
          variantId: variant ? variant.id : null,
          available: available,
          product: product
        };
      })
      .catch(function () {
        return {
          handle: def.handle,
          key: def.key || def.handle,
          optionLabel: def.optionLabel || "",
          displayTitle: def.displayTitle || def.handle,
          title: def.displayTitle || def.handle,
          shortLabel: def.shortLabel || def.displayTitle || def.handle,
          model: def.model || "",
          description: def.description || "",
          image: "",
          variantId: null,
          available: false,
          loadError: true
        };
      });
  }

  function getSelectedMachineIndex(handle) {
    for (var i = 0; i < state.selectedMachines.length; i++) {
      if (state.selectedMachines[i].handle === handle) return i;
    }

    return -1;
  }

  function renderCard(item, type) {
    var selectedIndex = -1;
    var isSelected = false;
    var isLocked = false;

    if (type === "battery") {
      isSelected = Boolean(state.selectedBattery && state.selectedBattery.handle === item.handle);
    }

    if (type === "machine") {
      selectedIndex = getSelectedMachineIndex(item.handle);
      isSelected = selectedIndex > -1;
      isLocked = !isSelected && state.selectedMachines.length >= CONFIG.maxMachines;
    }

    var classes = "xr-card";
    if (isSelected) classes += " is-selected";
    if (isLocked) classes += " is-locked";
    if (!item.available) classes += " is-unavailable";

    var imageHtml = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.displayTitle) + '" loading="lazy">'
      : '<div class="xr-select__image-missing">Bild nicht verfügbar</div>';

    var badgeText = type === "battery" ? item.optionLabel : "Maschine";
    var checkText = isSelected ? "✓" : "";
    var orderText = "";

    if (type === "battery" && isSelected) {
      orderText = "Gewählt";
    }

    if (type === "machine" && isSelected) {
      orderText = "Auswahl " + (selectedIndex + 1);
    }

    var selectText = "Auswählen";

    if (isSelected) selectText = "Ausgewählt";
    if (isLocked) selectText = "3 Maschinen erreicht";
    if (!item.available) selectText = "Nicht verfügbar";

    var description = item.description || "18V XR Aktionsmaschine für KONFEXRON.";
    if (type === "machine") description = "Als eine von drei Maschinen für dein Set wählbar.";
    if (!item.available) description = "Dieser Artikel ist aktuell nicht auswählbar.";

    return ""
      + '<button type="button" class="' + classes + '" data-type="' + type + '" data-handle="' + escapeHtml(item.handle) + '">'
      + '  <div class="xr-card__selected-glow"></div>'
      + '  <div class="xr-card__top">'
      + '    <span class="xr-card__badge">' + escapeHtml(badgeText) + '</span>'
      + '    <span class="xr-card__check">' + checkText + '</span>'
      + '  </div>'
      + '  <span class="xr-card__order">' + escapeHtml(orderText) + '</span>'
      + '  <div class="xr-card__image-wrap">'
      + '    <div class="xr-card__image-stage">' + imageHtml + '</div>'
      + '  </div>'
      + '  <div class="xr-card__body">'
      + '    <div class="xr-card__meta">'
      + '      <span>' + escapeHtml(item.shortLabel || "XR") + '</span>'
      + (item.model ? '      <span>' + escapeHtml(item.model) + '</span>' : "")
      + '    </div>'
      + '    <h3>' + escapeHtml(item.displayTitle) + '</h3>'
      + '    <p>' + escapeHtml(description) + '</p>'
      + '    <div class="xr-card__footer">'
      + '      <span class="xr-card__select">' + escapeHtml(selectText) + '</span>'
      + '    </div>'
      + '  </div>'
      + '</button>';
  }

  function renderFreebie(item) {
    var imageHtml = item.image
      ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.displayTitle) + '" loading="lazy">'
      : '<div class="xr-select__image-missing">Bild nicht verfügbar</div>';

    return ""
      + '<div class="xr-free">'
      + '  <div class="xr-free__image">' + imageHtml + '</div>'
      + '  <div>'
      + '    <h3>' + escapeHtml(item.displayTitle) + '</h3>'
      + '    <p>Automatisch inklusive</p>'
      + '  </div>'
      + '</div>';
  }

  function renderAll() {
    els.batteryOptions.innerHTML = CONFIG.batteryOptions
      .map(function (def) { return state.products[def.handle]; })
      .filter(Boolean)
      .map(function (item) { return renderCard(item, "battery"); })
      .join("");

    els.machineGrid.innerHTML = CONFIG.machines
      .map(function (def) { return state.products[def.handle]; })
      .filter(Boolean)
      .map(function (item) { return renderCard(item, "machine"); })
      .join("");

    els.freebieGrid.innerHTML = CONFIG.freebies
      .map(function (def) { return state.products[def.handle]; })
      .filter(Boolean)
      .map(renderFreebie)
      .join("");

    bindCardEvents();
    updateUi();
  }

  function bindCardEvents() {
    var buttons = container.querySelectorAll(".xr-card");

    buttons.forEach(function (button) {
      button.addEventListener("click", function () {
        var type = button.getAttribute("data-type");
        var handle = button.getAttribute("data-handle");
        var item = state.products[handle];

        if (!item || !item.available) {
          showMessage("Dieser Artikel ist aktuell nicht auswählbar.");
          return;
        }

        if (type === "battery") {
          state.selectedBattery = item;
          showMessage("Akku-Set ausgewählt.");
          scrollSoftlyToStep("xr-step-2");
        }

        if (type === "machine") {
          toggleMachine(item);
        }

        renderAll();
      });
    });
  }

  function scrollSoftlyToStep(id) {
    var target = document.getElementById(id);
    if (!target) return;

    setTimeout(function () {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }, 120);
  }

  function toggleMachine(item) {
    var existingIndex = getSelectedMachineIndex(item.handle);

    if (existingIndex > -1) {
      state.selectedMachines.splice(existingIndex, 1);
      showMessage("Maschine wurde abgewählt.");
      return;
    }

    if (state.selectedMachines.length >= CONFIG.maxMachines) {
      showMessage("Du hast bereits 3 Maschinen gewählt. Entferne zuerst eine gewählte Maschine, wenn du wechseln möchtest.");
      return;
    }

    state.selectedMachines.push(item);

    if (state.selectedMachines.length === CONFIG.maxMachines) {
      showMessage("Perfekt. 3 Maschinen gewählt. Dein Set ist bereit.");
      scrollSoftlyToStep("xr-step-3");
    } else {
      showMessage("Maschine " + state.selectedMachines.length + " von 3 ausgewählt.");
    }
  }

  function updateUi() {
    var machineCount = state.selectedMachines.length;
    var hasBattery = Boolean(state.selectedBattery);
    var isComplete = hasBattery && machineCount === CONFIG.maxMachines;

    els.machineCount.textContent = machineCount;

    var progress = 0;
    if (hasBattery) progress += 34;
    progress += Math.round((machineCount / CONFIG.maxMachines) * 46);
    if (isComplete) progress = 100;

    els.progressBar.style.width = progress + "%";

    if (!hasBattery) {
      els.statusStep.textContent = "Schritt 1 von 3";
      els.statusTitle.textContent = "Wähle dein Akku-Set";
    } else if (machineCount < CONFIG.maxMachines) {
      els.statusStep.textContent = "Schritt 2 von 3";
      els.statusTitle.textContent = "Wähle noch " + (CONFIG.maxMachines - machineCount) + " Maschine(n)";
    } else {
      els.statusStep.textContent = "Schritt 3 von 3";
      els.statusTitle.textContent = "Dein KONFEXRON ist bereit";
    }

    els.addButton.disabled = !isComplete || state.isAdding;

    updateSummary();
  }

  function updateSummary() {
    var batteryText = state.selectedBattery
      ? escapeHtml(state.selectedBattery.displayTitle)
      : "Noch nicht gewählt";

    var machinePills = "";

    if (state.selectedMachines.length) {
      machinePills = '<div class="xr-select__summary-pills">'
        + state.selectedMachines.map(function (item, index) {
          return '<span class="xr-select__summary-pill">' + (index + 1) + ". " + escapeHtml(item.displayTitle) + "</span>";
        }).join("")
        + "</div>";
    } else {
      machinePills = '<div class="xr-select__summary-pills"><span class="xr-select__summary-pill">Noch keine Maschine gewählt</span></div>';
    }

    var freebiePills = '<div class="xr-select__summary-pills">'
      + '<span class="xr-select__summary-pill">Stanley Wasserwaage</span>'
      + '<span class="xr-select__summary-pill">Stanley Cutter</span>'
      + '<span class="xr-select__summary-pill">Stanley Bandmaß</span>'
      + '<span class="xr-select__summary-pill">DEWALT Werkzeugtasche</span>'
      + "</div>";

    els.selectionSummary.innerHTML = ""
      + "<strong>Akku-Set:</strong> " + batteryText
      + "<br><br><strong>Maschinen:</strong>"
      + machinePills
      + "<br><strong>Gratis dabei:</strong>"
      + freebiePills;
  }

  function showMessage(text) {
    els.message.textContent = text || "";
  }

  function buildCartItems() {
    var setId = "KONFEXRON-" + Date.now();
    var priceProduct = state.products[CONFIG.priceProduct.handle];

    var baseProperties = {
      "Aktion": CONFIG.setName,
      "Set-ID": setId,
      "Setpreis": CONFIG.setPriceLabel
    };

    var items = [];

    items.push({
      id: priceProduct.variantId,
      quantity: 1,
      properties: Object.assign({}, baseProperties, {
        "Position": "Aktionspreis",
        "Hinweis": "Preisanker für KONFEXRON"
      })
    });

    items.push({
      id: state.selectedBattery.variantId,
      quantity: 1,
      properties: Object.assign({}, baseProperties, {
        "Position": "Akku-Set",
        "Akku-Option": state.selectedBattery.optionLabel || state.selectedBattery.displayTitle
      })
    });

    state.selectedMachines.forEach(function (machine, index) {
      items.push({
        id: machine.variantId,
        quantity: 1,
        properties: Object.assign({}, baseProperties, {
          "Position": "Maschine " + (index + 1),
          "Auswahl": machine.displayTitle
        })
      });
    });

    CONFIG.freebies.forEach(function (def) {
      var freebie = state.products[def.handle];

      if (!freebie || !freebie.variantId) return;

      items.push({
        id: freebie.variantId,
        quantity: 1,
        properties: Object.assign({}, baseProperties, {
          "Position": "Gratisbeilage",
          "Gratis": "Ja"
        })
      });
    });

    return items;
  }

  function validateBeforeAdd() {
    var priceProduct = state.products[CONFIG.priceProduct.handle];

    if (!priceProduct || !priceProduct.variantId) {
      showMessage("Das 899-€-Aktionspreis-Produkt wurde nicht gefunden. Prüfe den Handle in der JS-Datei.");
      return false;
    }

    if (!state.selectedBattery) {
      showMessage("Bitte wähle zuerst ein Akku-Set aus.");
      return false;
    }

    if (state.selectedMachines.length !== CONFIG.maxMachines) {
      showMessage("Bitte wähle genau 3 Maschinen aus.");
      return false;
    }

    if (!state.selectedBattery.variantId) {
      showMessage("Das gewählte Akku-Set ist aktuell nicht verfügbar.");
      return false;
    }

    for (var i = 0; i < state.selectedMachines.length; i++) {
      if (!state.selectedMachines[i].variantId) {
        showMessage("Eine der gewählten Maschinen ist aktuell nicht verfügbar.");
        return false;
      }
    }

    for (var f = 0; f < CONFIG.freebies.length; f++) {
      var freebie = state.products[CONFIG.freebies[f].handle];

      if (!freebie || !freebie.variantId) {
        showMessage("Ein Gratisartikel ist aktuell nicht verfügbar. Bitte prüfe die Gratisartikel-Produkte.");
        return false;
      }
    }

    return true;
  }

  function addSetToCart() {
    if (state.isAdding) return;
    if (!validateBeforeAdd()) return;

    state.isAdding = true;
    els.addButton.disabled = true;

    var buttonText = els.addButton.querySelector("span");
    if (buttonText) buttonText.textContent = "Set wird hinzugefügt …";

    showMessage("");

    fetch(buildCartAddUrl(), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        items: buildCartItems()
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (error) {
            throw error;
          });
        }

        return response.json();
      })
      .then(function () {
        window.location.href = root + "cart";
      })
      .catch(function (error) {
        var message = "Das Set konnte nicht in den Warenkorb gelegt werden.";

        if (error && error.description) {
          message = error.description;
        } else if (error && error.message) {
          message = error.message;
        }

        showMessage(message);

        state.isAdding = false;

        var buttonText = els.addButton.querySelector("span");
        if (buttonText) buttonText.textContent = "Aktionsset sichern";

        updateUi();
      });
  }

  function loadAllProducts() {
    var allDefs = []
      .concat([CONFIG.priceProduct])
      .concat(CONFIG.batteryOptions)
      .concat(CONFIG.machines)
      .concat(CONFIG.freebies);

    Promise.all(allDefs.map(fetchProduct))
      .then(function (products) {
        products.forEach(function (product) {
          state.products[product.handle] = product;
        });

        renderAll();

        setTimeout(function () {
          container.classList.add("is-ready");
        }, 80);
      })
      .catch(function () {
        els.batteryOptions.innerHTML = '<div class="xr-select__loader">Produkte konnten nicht geladen werden.</div>';
        els.machineGrid.innerHTML = "";
        els.freebieGrid.innerHTML = "";
      });
  }

  els.addButton.addEventListener("click", addSetToCart);

  loadAllProducts();
})();